/**
 * JB Product Scroll-Jacking
 * 
 * Desktop: Scroll vertical con sticky sidebar
 * - Las imágenes hacen scroll
 * - El panel de info se queda fijo (sticky)
 * - Cuando terminas de ver las imágenes, el scroll continúa normal
 */

class JBProductScroll {
  constructor() {
    this.gallery = document.querySelector('[data-product-gallery]');
    this.infoPanel = document.querySelector('[data-product-info-sticky]');
    this.galleryItems = document.querySelectorAll('.jb-product-gallery__item');
    
    if (!this.gallery || !this.infoPanel || window.innerWidth <= 768) {
      return; // Solo en desktop
    }
    
    this.init();
  }
  
  init() {
    this.setupStickyBehavior();
    this.observeGalleryEnd();
  }
  
  setupStickyBehavior() {
    // El panel de info ya es sticky por CSS
    // Aquí podemos agregar comportamientos adicionales si es necesario
    
    // Calcular altura total de la galería
    const galleryHeight = this.gallery.scrollHeight;
    const viewportHeight = window.innerHeight;
    
    // Agregar data attribute para uso en CSS
    this.gallery.setAttribute('data-gallery-height', galleryHeight);
    this.gallery.setAttribute('data-viewport-height', viewportHeight);
  }
  
  observeGalleryEnd() {
    // Observar cuando el último item de la galería es visible
    const lastItem = this.galleryItems[this.galleryItems.length - 1];
    
    if (!lastItem) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Última imagen visible - permitir scroll normal
          document.body.classList.add('jb-gallery-complete');
        } else {
          document.body.classList.remove('jb-gallery-complete');
        }
      });
    }, {
      threshold: 0.5 // 50% visible
    });
    
    observer.observe(lastItem);
  }
  
  // Método para scroll suave a una imagen específica
  scrollToImage(index) {
    const targetItem = this.galleryItems[index];
    if (targetItem) {
      targetItem.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new JBProductScroll();
  });
} else {
  new JBProductScroll();
}

// Re-inicializar en resize (por si cambia de mobile a desktop)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    new JBProductScroll();
  }, 250);
});
